import { ErrorCode } from './error-code.enum';

export class ErrorWCode extends Error {
  errorCode: ErrorCode;
  constructor(message: string, errorCode: ErrorCode) {
    super(message);
    this.name = ErrorWCode.name;
    this.errorCode = errorCode;
  }
}
